// extracted by mini-css-extract-plugin
export default {"tagline":"SearchResultsTagline_tagline__1E3a5"};